/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maple_Flat_Snail_LeapInputs */

const en_maple_flat_snail_leap = /** @type {(inputs: Maple_Flat_Snail_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Held`)
};

const de_maple_flat_snail_leap = /** @type {(inputs: Maple_Flat_Snail_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurückgehalten`)
};

/**
* | output |
* | --- |
* | "Held" |
*
* @param {Maple_Flat_Snail_LeapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const maple_flat_snail_leap = /** @type {((inputs?: Maple_Flat_Snail_LeapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maple_Flat_Snail_LeapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_maple_flat_snail_leap(inputs)
	return de_maple_flat_snail_leap(inputs)
});